module.exports = __webpack_public_path__ + "img/维修费用率@3x.e481da83.png";